var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.33333C4.32 1.33333 1.33333 4.32 1.33333 8C1.33333 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8C14.6667 4.32 11.68 1.33333 8 1.33333ZM4.71354 12.1867C5.00021 11.5867 6.74687 11 8.00021 11C9.25354 11 11.0069 11.5867 11.2869 12.1867C10.3802 12.9067 9.24021 13.3333 8.00021 13.3333C6.76021 13.3333 5.62021 12.9067 4.71354 12.1867ZM8 9.66667C8.97333 9.66667 11.2867 10.06 12.24 11.22C12.92 10.3267 13.3333 9.21333 13.3333 8C13.3333 5.06 10.94 2.66667 8 2.66667C5.06 2.66667 2.66667 5.06 2.66667 8C2.66667 9.21333 3.08 10.3267 3.76 11.22C4.71333 10.06 7.02667 9.66667 8 9.66667ZM8 4C6.70667 4 5.66667 5.04 5.66667 6.33333C5.66667 7.62667 6.70667 8.66667 8 8.66667C9.29333 8.66667 10.3333 7.62667 10.3333 6.33333C10.3333 5.04 9.29333 4 8 4ZM7 6.33333C7 6.88667 7.44667 7.33333 8 7.33333C8.55333 7.33333 9 6.88667 9 6.33333C9 5.78 8.55333 5.33333 8 5.33333C7.44667 5.33333 7 5.78 7 6.33333Z",
    fill: "#264F3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.54a4fb6f.svg";
export { ForwardRef as ReactComponent };